import { render, staticRenderFns } from "./GroupUser.vue?vue&type=template&id=864f2a62&lang=html"
import script from "./GroupUser.vue?vue&type=script&lang=js"
export * from "./GroupUser.vue?vue&type=script&lang=js"
import style0 from "./GroupUser.vue?vue&type=style&index=0&id=864f2a62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports